import { useTemplateCategories } from "@hooks/useTemplateCategories";
import { cn, getInitials } from "@utils/index";
import React from "react";
import { PiSparkleBold } from "react-icons/pi";

export default function TemplateCategoriesSelector({
  selectedCategoryId,
  onClick,
}: {
  selectedCategoryId?: number;
  onClick?: (catId?: number) => void;
}) {
  const { templateCategories } = useTemplateCategories();

  function singleCategory({
    id,
    selected,
    name,
  }: {
    id?: number;
    selected: boolean;
    name: string;
  }) {
    return (
      <button
        className="group flex w-full cursor-pointer flex-col items-center justify-center gap-2"
        onClick={() => {
          if (onClick) onClick(id);
        }}
      >
        <div
          className={cn(
            "flex aspect-square w-12 items-center justify-center rounded-full bg-primary/10 text-lg text-primary transition-all",
            selected && "bg-primary text-primary-foreground",
            !selected && "group-hover:bg-primary/30",
          )}
        >
          {id === undefined ? <PiSparkleBold /> : getInitials(name ?? "")}
        </div>
        <p className="whitespace-nowrap text-xs font-medium text-gray-500 dark:text-gray-200">
          {name}
        </p>
      </button>
    );
  }

  if (!templateCategories?.length) return <></>;

  return (
    <div className="m-auto flex w-full flex-nowrap items-center gap-10 overflow-scroll whitespace-nowrap border-b py-2">
      <div className="ml-auto">
        {singleCategory({
          name: "For You",
          selected:
            selectedCategoryId === null || selectedCategoryId === undefined,
          id: undefined,
        })}
      </div>
      {(templateCategories ?? []).map((category, idx) => (
        <div
          key={`category_${idx}`}
          className={
            idx === (templateCategories ?? []).length - 1 ? "mr-auto" : ""
          }
        >
          {singleCategory({
            name: category.name ?? "",
            selected: selectedCategoryId === category.id,
            id: category.id,
          })}
        </div>
      ))}
    </div>
  );
}
